<template>
  <!-- NOTE (TEMPLATE) to show the specific proposal page -->

  <div>
    <b-modal id="loading" hide-header hide-footer centered no-close-on-backdrop>
      <div style="text-align: center">
        <span>در حال بارگذاری ...لطفا کمی صبر نمایید</span>
        <b-spinner type="grow" label="Loading..."></b-spinner>
      </div>
    </b-modal>
    <Order role="salesManager" />
  </div>
</template>

<script>
import Order from "../../components/Order"; // NOTE (IMPORT) component of proposal

export default {
  components: { Order }, // NOTE (c-proposal) component of proposal
  data() {
    return {};
  },
  mounted() {
    // NOTE (MOUNTED) to show loading at the beginning
    // this.$bvModal.show("loading");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-bottom: 1px solid #c8ced3;
}

</style>
